import {
  combineReducers
} from "redux"
import {
  routerActionTypes,
  flashActionTypes,
  serviceActionTypes,
  notificationsActionTypes,
  uiStateActionTypes
} from "../actions/mymazda"
import uniqBy from "lodash/uniqBy"
// Reducer

const flashMessageReducer = (state = [], {
  payload,
  type
}) => {
  switch (type) {
  case flashActionTypes.MYMAZDA_FLASH_ADD_MESSAGE:
    return [...state, {
      id: payload.id,
      message: payload.message,
      type: payload.type
    }]
  case flashActionTypes.MYMAZDA_FLASH_REMOVE_MESSAGE:
    return state.filter(message => message.id !== payload.id)
  default:
    return state
  }
}

const mymazdaRouteReducer = (state = {
  cache: {}
}, {
  payload,
  type
} = {}) => {
  switch (type) {
  case routerActionTypes.MYMAZDA_HYDRATE_ROUTE_COMPONENTS:
    return {
      ...state,
      [payload.route]: {
        ...state[payload.route]
      }
    }
  case routerActionTypes.MYMAZDA_REGISTER_ROUTES:
    return {
      ...state,
      ...payload.routes
    }
  case routerActionTypes.MYMAZDA_FETCH_START:
    return {
      ...state,
      [payload.route]: {
        ...state[payload.route],
        fetchError: "",
        isFetching: true
      }
    }
  case routerActionTypes.MYMAZDA_FETCH_ERROR:
    return {
      ...state,
      [payload.route]: {
        ...state[payload.route],
        fetchError: payload.error,
        isFetching: false
      }
    }
  case routerActionTypes.MYMAZDA_FETCH_SUCCESS:
    return {
      ...state,
      [payload.route]: {
        ...state[payload.route],
        fetchError: "",
        isFetching: false
      }
    }
  default:
    return state
  }
}

const pageCacheReducer = (state = {}, {
  payload,
  type
} = {}) => {
  switch (type) {
  case routerActionTypes.MYMAZDA_HYDRATE_ROUTE_COMPONENTS:
    return {
      ...state,
      [payload.key]: payload.components
    }
  case routerActionTypes.MYMAZDA_FETCH_SUCCESS:
    return {
      ...state,
      [payload.key]: payload.components
    }
  default:
    return state
  }
}

const serviceReducer = (state = {}, {
  payload,
  type
} = {}) => {
  switch (type) {
  case serviceActionTypes.MYMAZDA_UPDATE_SERVICE_DETAILS:
    return {
      ...state,
      [payload.vin]: payload.service
    }
  default:
    return state
  }
}

const notificationsReducer = (state = [], {
  payload,
  type
} = {}) => {
  switch (type) {
  case notificationsActionTypes.MYMAZDA_SAVE_NOTIFICATIONS:
    return uniqBy([...payload.notifications, ...state], "notificationID")
  default:
    return state
  }
}

const uiStateReducer = (state = {
  expandedNavItemIndex: -1,
  navigationOpen: false,
  userMenuOpen: false,
  notificationMenuOpen: false
}, {
  payload,
  type
} = {}) => {
  switch (type) {
  case uiStateActionTypes.MYMAZDA_TOGGLE_USER:
    return {
      ...state,
      navigationOpen: false,
      notificationMenuOpen: false,
      userMenuOpen: !state.userMenuOpen
    }
  case uiStateActionTypes.MYMAZDA_TOGGLE_NOTIFICATIONS:
    return {
      ...state,
      navigationOpen: false,
      userMenuOpen: false,
      notificationMenuOpen: !state.notificationMenuOpen
    }
  case uiStateActionTypes.MYMAZDA_TOGGLE_NAV:
    return {
      ...state,
      userMenuOpen: false,
      notificationMenuOpen: false,
      navigationOpen: !state.navigationOpen
    }
  case uiStateActionTypes.MYMAZDA_CLOSE_ALL:
    return {
      ...state,
      navigationOpen: false,
      userMenuOpen: false,
      notificationMenuOpen: false
    }
  case uiStateActionTypes.MYMAZDA_EXPAND_NAV_ITEM:
    return {
      ...state,
      expandedNavItemIndex: payload.index
    }
  case uiStateActionTypes.MYMAZDA_TOGGLE_NAV_ITEM:
    return {
      ...state,
      expandedNavItemIndex: payload.index === state.expandedNavItemIndex ? -1 : payload.index
    }
  default:
    return state
  }
}

const mymazda = combineReducers({
  routes: mymazdaRouteReducer,
  flashMessages: flashMessageReducer,
  cache: pageCacheReducer,
  service: serviceReducer,
  notifications: notificationsReducer,
  uiState: uiStateReducer
})

export default mymazda



// WEBPACK FOOTER //
// ./src/store/reducers/mymazda.js